import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

interface ITitleRowProps {
  level: number;
};

interface IEditable{
  isEditable?: boolean;
}

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  height: 26px;
  flex-grow: 0;
  font-family: Roboto;
  align-items: center;
  padding-left: ${(props: ITitleRowProps) => (25 + (props.level*8)).toString() + 'px;'}
  padding-right: 5px;
`;

export const ArrowDown = styled.div`
  width: 0; 
  height: 0; 
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #686363;
  margin-right: 4px;
`;

export const GroupContent = styled.div`
`;

export const Title = styled.div`
  margin-left: 5px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #122442;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 5px;
  padding-left: 2px;
  cursor: pointer;
  text-align: left;
  width: 100%;
`;

export const IconContainer = styled.div`
  cursor: pointer;
`;

export const VisibilityIconContainer = styled.div`
  cursor: pointer;
`;

export const EditContainer = styled.input`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;  
  color: #122442;
  width: 95%;  
  border: 1px solid #204078;
  background-color: 'white';
  border-radius: 3px;
  outline: none !important;
`;